import React, { useCallback, useEffect, useState } from "react";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import { Image, Stack } from "react-bootstrap";
import {
  GenericModalProps,
  ThemeVariant,
} from "../../utils/constants/generic-types";
import "./GetHyperOnTestFlightModal.scss";
import TestflightInstallationFlow from "../TestFlightInstallationFlow/TestFlightInstallationFlow";
import ImageStepOne from "../../images/step-one.png";
import ImageTestflightScreenshot from "../../images/testflight-screenshot.png";
import ImageInstallHyperScreenshot from "../../images/install-hyper-screenshot.png";
import ImageStepTwo from "../../images/step-two.png";

export default function GetHyperOnTestFlightModal({
  isOpen,
  onClose,
  theme = ThemeVariant.LIGHT,
}: GenericModalProps & { theme?: ThemeVariant }) {
  const [isCompleted, setIsCompleted] = useState(false);
  const [hasInstalledTestflight, setHasInstalledTestflight] = useState(false);

  const handleClose = useCallback(() => {
    setHasInstalledTestflight(false);
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (isCompleted) {
      handleClose();
    }
  }, [handleClose, isCompleted]);

  return (
    <BottomDrawer
      isOpen={isOpen}
      onClose={handleClose}
      containerClass="GetHyperOnTestFlightDrawer"
      closeBtnStyles={{ marginRight: 16, marginTop: 16 }}
    >
      <Stack className="GetHyperOnTestFlight">
        <Stack gap={2} className="align-items-center DialogText">
          <div className="fs-6 Hanson-700 SpecialFontSettings Title mb-4">
            <Image
              src={hasInstalledTestflight ? ImageStepTwo : ImageStepOne}
              alt={hasInstalledTestflight ? "step two" : "step one"}
            />
          </div>
          <Image
            src={
              hasInstalledTestflight
                ? ImageInstallHyperScreenshot
                : ImageTestflightScreenshot
            }
            className="screenshot"
          />
        </Stack>
        <TestflightInstallationFlow
          isLightMode={theme === ThemeVariant.LIGHT}
          hasCompletedAllSteps={isCompleted}
          setHasCompletedAllSteps={setIsCompleted}
          hasInstalledTestflight={hasInstalledTestflight}
          setHasInstalledTestflight={setHasInstalledTestflight}
        />
      </Stack>
    </BottomDrawer>
  );
}
